import { render, staticRenderFns } from "./ForensicDiagnosis.vue?vue&type=template&id=fabe1e92&lang=pug&"
import script from "./ForensicDiagnosis.vue?vue&type=script&lang=js&"
export * from "./ForensicDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./ForensicDiagnosis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports